<template>
  <BlockFieldset class="project-base-configuration">
    <SolarPlantItems :project="project" />
    <div v-if="!isBlockReadOnly" class="text-right mt-2">
      <b-button variant="bg" :disabled="isSaving" @click="save">
        {{ $t('saveNamed', { name: $t('baseConfiguration') }) }}
      </b-button>
    </div>
  </BlockFieldset>
</template>

<script>
import { mapActions } from 'vuex';
import SolarPlantItems from '@/components/SolarPlant/SolarPlantItems.vue';
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { BlockSaveMixin } from '@/mixins/blockSave';
import { toProjectBaseConfigurationInput } from './projectBaseConfigurationInput';

/**
 * Block project-base-configuration (ADR 0006 D3): solar plant items, saved through its own
 * mutation with its own button. Emits `dirty` (boolean) and `saved`.
 */
export default {
  name: 'ProjectBaseConfiguration',
  components: {
    BlockFieldset,
    SolarPlantItems,
  },
  mixins: [AccessBlockMixin, BlockSaveMixin],
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  computed: {
    blockInput() {
      return toProjectBaseConfigurationInput(this.project.solarPlant);
    },
  },
  methods: {
    ...mapActions(['updateProjectBaseConfiguration']),
    saveBlockInput(input) {
      return this.updateProjectBaseConfiguration({ projectNumber: this.project.number, input });
    },
  },
};
</script>
